import React from "react";
import BatchPrint from "../BatchPrint";
import ParentContent from "./ParentContent";

import { fetchParentReport } from "../../services/parent/fetchParentReport";
import { fetchReport as fetchProgressReport } from "../../services/progress";

// Batch Print for Parent Report

export default function ParentReportBatchPrint(props) {
  return (
    <BatchPrint
      title="Parent Report"
      getStudentData={getStudentData}
      renderReport={renderReport}
    />
  );

  async function getStudentData(student, selections) {
    const { metric, scale, benchmark, customBenchmarks, equating, locale, reportConfig, selectedStatePercentileCuts, assessmentTypeFilter } =
      selections;
    const [parentReport, [progressReport]] = await Promise.all([
      fetchParentReport(student, metric, benchmark, customBenchmarks, reportConfig, equating, locale, selectedStatePercentileCuts, assessmentTypeFilter),
      fetchProgressReport(
        student,
        metric.value,
        scale.value,
        benchmark,
        customBenchmarks,
        equating,
        locale,
        {skipARM: true},
        selectedStatePercentileCuts
      ),
    ]);
    return { student, parentReport, progressReport };
  }

  function renderReport(report) {
    if (!report) return null;
    if(!report.parentReport || !report.progressReport) return null;
    if(report.parentReport.reportNotAvailable) return null;
    return (
      <ParentContent
        small={props.small}
        key={report.student.value}
        name={report.student.label}
        parentReport={report.parentReport}
        progressReport={report.progressReport}
        batchPrinting={true}
      />
    );
  }
}
